// extracted by mini-css-extract-plugin
export default {"modalMask":"Modal_modalMask__V5LLR","modalBody":"Modal_modalBody__38Ueg"};